import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../../contexts/AuthContext";
import html2pdf from "html2pdf.js";
import { printHtmlBase } from "./DocumentPrintBatchPage";

export default function DocumentPrintBatchDownloadPdfPage() {
    const { codes = "", userId, code = "" } = useParams();
    const codeList = codes ? codes.split(",") : [];
    const [html, setHtml] = useState("");
    const { getUserData } = useContext(AuthContext);
    const user = getUserData();
    const containerRef = useRef(null);

    useEffect(() => {
        const load = printHtmlBase(codeList, code, user, setHtml);
        load();
    }, [codes, userId]);

    useEffect(() => {
        if (html && containerRef.current) {
            setTimeout(() => {
                html2pdf()
                    .set({
                        margin: 0,
                        filename: 'documentos.pdf',
                        image: { type: 'jpeg', quality: 0.98 },
                        html2canvas: { scale: 2, letterRendering: true },
                        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
                    })
                    .from(containerRef.current)
                    .save();
            }, 100);
        }
    }, [html]);

    return (
        <div ref={containerRef} dangerouslySetInnerHTML={{ __html: html }} />
    );
}
